export const colorPallet = {
  white: '#FFFFFF',
  whitesmoke: '#F5F5F5',
  whitesmokeLight: '#F0F0F0',
  gray14: '#242424',
  veryLightGrey: '#C7C7C7',
  dimGray: '#616161',
  black: '#000000',
  lightGrey: '#D1D1D1',
  slateBlue: '#5B5FC7',
  richBlue: '#4F52B2',
  darkSlateBlue: '#444791',
  lightSlateBlue: '#7F85F5',
  nero: '#1F1F1F',
  nero2: '#141414',
  charcoal: '#424242',
  darkGray: '#ADADAD',
  lavender: '#E8EBFA',
  oldRose: '#C4314B',
  islamicGreen: '#13A10E',
  selectiveYellow: '#FFB900',
  navyBlue: '#0078D4',
  blueLagoon: '#00666D',
  green: '#0B6A0B',
  quartz: '#DCE0FA',
  perano: '#ADB4EC',
  richBlueDark: '#4F51B1',
  mediumSlateBlue: '#7A80E9',
  lightGreylight: '#D6D6D6',
  eclipse: '#3E3E3E',
  gainsboro: '#E0E0E0',
  nightRider: '#333333',
  seashell: '#F9F8F7',
  nobel: '#999999',
  pippin: 'FBDED7',
  darkOpacity: 'rgb(0,0,0, 0.7)',
  lightOpacity: 'rgb(36,36,36, 0.5)',
  whiteSmokeVeryLight: '#F2F2F2',
  myrtle: '#0D2E0D',
  pixieGreen: '#BDDA9B',
  salem: '#237B4B',
  mantis: '#92C353',
  whisper: '#EBEBEB',
  temptress: '#3E1F25',
  lavenderBlush: '#FCF4F6',
  paleRose: '#F3D6D8',
  rusticRed: '#1E040A',
  cornFlowerBlue: '#464775',
  gainsboroDark: '#D9D9D9',
  darkGrayLigth: '#ABABAB',
  darkGrayLigthV2: '#AFAFAF',
  quartzBlue: '#DAE0FF',
  peranoBlue: '#B6C2FF',
  lightGray: '#3D3D3D',
  bazaar: '#837777',
  purpleDark: '#D8D9F5',
  zambezi: '#5C5B5B',
  lavenderV2: '#EBEBF0',
  jaguar: '#242429',
  blackV2: '#0F0F0F',
  gainsboroV2: '#E0E0E0',
  jacksonsPurple: '#3D3E78',
  bokaraGrey: '#252423',
  shuttleGrey: '#616365',
  neroV2: '#292929',
  matterhorn: '#515151',
  lightGreyV2: '#D3D3D3',
  whisperV2: '#E6E6E6',
  weekHoverLight: '#DCDFFA',
  weekHoverDark: '#383966',
  watermelon: '#F75E75',
  christi: '#6bb700',
  snow: '#FAFAFA',
  matterhornV2: '#525252',
  neroV3: '#1E1E1E',
  portage: '#9299F7',
  fireEngineRed: '#C50F1F',
  blossom: '#eeacb2',
  lavenderBlushV2: '#fdf3f4',
  rusticRedV2: '#3B0509',
  venetianRed: '#B10E1C',
};

export const colorPalletLight = {
  mainBackgorund: colorPallet.white,
  calendarDateColor: colorPallet.black,
  calendarDateColorHover: colorPallet.black,
  popupMainBackground: colorPallet.whitesmoke,
  popupVacationHoverBackground: colorPallet.whitesmoke,
  popupOpacity: colorPallet.lightOpacity,
  popupParagraphColor: colorPallet.dimGray,
  popupInputMainBackground: colorPallet.white,
  popupInputBorderColor: colorPallet.gainsboro,
  widgetMainBackground: colorPallet.white,
  textMainColor: colorPallet.gray14,
  selectedDateBackground: colorPallet.slateBlue,
  popupErrorColor: colorPallet.oldRose,
  calendarDividerColor: colorPallet.lightGrey,
  calendarGreyedDays: colorPallet.dimGray,
  bonusPaidDaysBackground: colorPallet.seashell,
  bonusPaidDaysColor: colorPallet.charcoal,
  bonusPaidDaysOptionColor: colorPallet.richBlue,
  dividerMainColor: colorPallet.lightGrey,
  timeOffButtonBackground: colorPallet.richBlue,
  timeOffButtonColor: colorPallet.white,
  datePickerBorderColor: colorPallet.gainsboro,
  datePickerDisabledDates: colorPallet.nobel,
  moreCircleIconColor: colorPallet.navyBlue,
  cancelCalendarIconColor: colorPallet.richBlue,
  cancelPopupTitleColor: colorPallet.gray14,
  successMessageBackground: colorPallet.pixieGreen,
  infoMessageBackground: colorPallet.lavenderBlush,
  successMessageColor: colorPallet.salem,
  infoMessageColor: colorPallet.oldRose,
  successMessageBorder: colorPallet.pixieGreen,
  infoMessageBorder: colorPallet.paleRose,
  suggestionBackground: colorPallet.white,
  suggestionHoverBackground: colorPallet.whisper,
  inputTextColor: colorPallet.dimGray,
  filterOptionCheckedBackground: colorPallet.lavender,
  backgroundCalendarDay: colorPallet.white,
  colorCalendarDay: colorPallet.white,
  defaultButtonColor: colorPallet.gray14,
  defaultButtonBackground: colorPallet.white,
  defaultButtonHoverBackground: colorPallet.gainsboroDark,
  defaultButtonActiveBackground: colorPallet.darkGrayLigthV2,
  defaultButtonBorderColor: colorPallet.veryLightGrey,
  primaryButtonBackground: colorPallet.slateBlue,
  primaryButtonBackgroundHover: colorPallet.richBlue,
  primaryButtonBackgroundActive: colorPallet.darkSlateBlue,
  primaryButtonColor: colorPallet.white,
  primaryButtonV2Background: colorPallet.lavender,
  primaryButtonV2BackgroundHover: colorPallet.quartzBlue,
  primaryButtonV2BackgroundActive: colorPallet.peranoBlue,
  primaryButtonV2Color: colorPallet.slateBlue,
  primaryButtonV2ColorHover: colorPallet.richBlue,
  primaryButtonV2ColorActive: colorPallet.darkSlateBlue,
  vaccationIndicatorPopupBackground: colorPallet.white,
  vaccationIndicatorTeamDetailsHeaderBackground: colorPallet.quartz,
  filterButtonColor: colorPallet.slateBlue,
  currentUserVacationBackgroundColor: colorPallet.purpleDark,
  tableBorders: colorPallet.slateBlue,
  tableHeadColor: colorPallet.lavender,
  tableHeadFont: colorPallet.zambezi,
  tableRowColor: colorPallet.white,
  tableRowHover: colorPallet.whitesmoke,
  tableRowFont: colorPallet.charcoal,
  tableRowBorder: colorPallet.lightGrey,
  tableOptionsColor: colorPallet.richBlue,
  tableOptionsBackground: colorPallet.white,
  tableOptionHover: colorPallet.lavender,
  tableSelectInput: colorPallet.white,
  tableHeadDivider: colorPallet.richBlue,

  timesheetsHeaderBackground: colorPallet.whitesmoke,
  timesheetsTableHeaderBackground: colorPallet.whitesmokeLight,
  timesheetsTableBodyBackground: colorPallet.white,
  timesheetsTableBodyHoursBackground: colorPallet.lavenderV2,
  timesheetsTableBorderColor: colorPallet.gainsboroV2,
  timesheetsTableCellBackgroundHover: colorPallet.lavender,
  timesheetsCalloutBackground: colorPallet.white,
  timesheetsTableTextMainColor: colorPallet.bokaraGrey,
  timesheetsTableTextSecondaryColor: colorPallet.shuttleGrey,
  timesheetsTableTextFooterColor: colorPallet.dimGray,
  timesheetsPopupInputBackground: colorPallet.whitesmoke,
  timesheetsPopupInputColor: colorPallet.lightGreyV2,
  timesheetsPopupBackground: colorPallet.white,
  timesheetsHourPillsBackground: colorPallet.whisperV2,
  timesheetsSumHoursColor: colorPallet.dimGray,
  timesheetsDatepickerBackground: colorPallet.white,
  timesheetsDatepikerColor: colorPallet.gray14,
  timesheetsDatepickerWeekSelectedBackGround: colorPallet.lavender,
  timesheetsDatepickerWeekHoverBackGround: colorPallet.weekHoverLight,
  timesheetsDatepickerSelectedWeekHoverBackGround: colorPallet.lavender,
  timesheetsCheckIconColor: colorPallet.salem,
  timesheetInfoIconColor: colorPallet.oldRose,
  timesheetsAlertBackground: colorPallet.lavenderBlush,
  timesheetsAlertBorder: colorPallet.paleRose,
  timesheetsSuccessOverlay: colorPallet.christi,
  timesheetsInputBorderColor: colorPallet.slateBlue,
  timesheetsNonWorkingDayCellBackgorund: colorPallet.snow,
  skillsBackground: colorPallet.snow,
  skillsMainBorderColor: colorPallet.lightGrey,
  skillsAccordionBackground: colorPallet.white,
  skillsAccordionOpenHeaderBackground: colorPallet.whitesmoke,
  skillsAccordionCloseHeaderBackground: colorPallet.white,
  skillsAccordionBorderColor: colorPallet.lightGrey,
  skillsPopupRadioSectionsDivider: colorPallet.lavender,
  skillsMainTextColor: colorPallet.gray14,
  skillsSecondaryTextColor: colorPallet.dimGray,
  skillsErrorBackground: colorPallet.lavenderBlushV2,
  skillsErrorMessageBorder: colorPallet.blossom,
  skillsErrorAlertIconColor: colorPallet.venetianRed,
  skillsEditButtonColor: colorPallet.white,
  skillsEditButtonBorder: colorPallet.veryLightGrey,
  skillsEditButtonBackground: colorPallet.white,
  skillsEditButtonTextColor: colorPallet.black,
  skillsButtonsColor: colorPallet.charcoal,
  skillsLabelColor: colorPallet.charcoal,
  skillsLevelTextColor: colorPallet.dimGray,
  skillTitleColor: colorPallet.gray14,
  skillLevelColor: colorPallet.dimGray,

  goalsTableContainerBackground: colorPallet.snow,
  goalsTableHeaderBackground: colorPallet.white,
  goalsCardBackground: colorPallet.white,
  goalsCardText: colorPallet.gray14,
  goalsCardCommentText: colorPallet.dimGray,
  goalsCardCommentLabel: colorPallet.slateBlue,
  goalsMenuItemColor: colorPallet.black,
  goalsRowDivider: colorPallet.gainsboro,
  goalsTextareaBackground: colorPallet.whitesmoke,

  feedbackBackground: colorPallet.whitesmoke,
  feedbackContainersBackground: colorPallet.white,
  feedbackDividersColor: colorPallet.gainsboro,
  feedbackAccordionSelected: colorPallet.lavender,
  feedbackCompanyValuesButtonBorderColor: colorPallet.lavender,
  feedbackEmployeeSuggestionHover: colorPallet.whitesmoke,

  serviceDeskNotesDivider: colorPallet.portage,
  serviceDeskNoteBackground: colorPallet.white,
  serviceDeskInputNoteBackground: colorPallet.whitesmoke,
  serviceDeskNoteBorder: colorPallet.gainsboro,
  serviceDeskFileAttachmentBorder: colorPallet.gainsboro,
  serviceDeskMainBackground: colorPallet.white,
  serviceDeskTextColorPrimary: colorPallet.gray14,
  serviceDeskTextColorSecondary: colorPallet.dimGray,
  serviceDeskTextColorTertiary: colorPallet.charcoal,
  serviceDeskTextColorWhite: colorPallet.white,
  serviceDeskRadioButtonColor: colorPallet.slateBlue,
  serviceDeskColorButtonRest: colorPallet.slateBlue,
  serviceDeskInputBackground: colorPallet.whitesmoke,
  serviceDeskInputDropDownBackground: colorPallet.white,
  serviceDeskInputDropDownHoverBackground: colorPallet.whitesmoke,
  serviceDeskFileAttachmentBackground: colorPallet.white,
  serviceDeskNoteInputText: colorPallet.black,
  serviceDeskSubmitButtonDisabled: colorPallet.dimGray,
  serviceDeskMobileFooterBackground: colorPallet.white,
  serviceDeskNotesErrors: colorPallet.oldRose,
  serviceDeskTableHeaderCellColor: colorPallet.dimGray,
  serviceDeskTableHeaderCellColorSortingActive: colorPallet.gray14,
};

export const colorPalletDark = {
  mainBackgorund: colorPallet.gray14,
  calendarDateColor: colorPallet.white,
  calendarDateColorHover: colorPallet.black,
  popupMainBackground: colorPallet.gray14,
  popupVacationHoverBackground: colorPallet.eclipse,
  popupOpacity: colorPallet.darkOpacity,
  popupParagraphColor: colorPallet.lightGreylight,
  popupInputMainBackground: colorPallet.nightRider,
  popupInputBorderColor: colorPallet.dimGray,
  widgetMainBackground: colorPallet.gray14,
  textMainColor: colorPallet.white,
  selectedDateBackground: colorPallet.mediumSlateBlue,
  popupErrorColor: colorPallet.oldRose,
  calendarDividerColor: colorPallet.lightGrey,
  calendarGreyedDays: colorPallet.veryLightGrey,
  bonusPaidDaysBackground: colorPallet.nero2,
  bonusPaidDaysColor: colorPallet.white,
  bonusPaidDaysOptionColor: colorPallet.lightSlateBlue,
  dividerMainColor: colorPallet.black,
  timeOffButtonBackground: colorPallet.darkSlateBlue,
  timeOffButtonColor: colorPallet.white,
  datePickerBorderColor: colorPallet.black,
  datePickerDisabledDates: colorPallet.veryLightGrey,
  moreCircleIconColor: colorPallet.navyBlue,
  cancelCalendarIconColor: colorPallet.mediumSlateBlue,
  cancelPopupTitleColor: colorPallet.whiteSmokeVeryLight,
  successMessageBackground: colorPallet.myrtle,
  infoMessageBackground: colorPallet.temptress,
  successMessageColor: colorPallet.mantis,
  infoMessageColor: colorPallet.oldRose,
  successMessageBorder: colorPallet.myrtle,
  infoMessageBorder: colorPallet.rusticRed,
  suggestionBackground: colorPallet.black,
  suggestionHoverBackground: colorPallet.gray14,
  inputTextColor: colorPallet.darkGray,
  filterOptionCheckedBackground: colorPallet.darkGray,
  backgroundCalendarDay: colorPallet.gray14,
  colorCalendarDay: colorPallet.black,
  defaultButtonColor: colorPallet.white,
  defaultButtonBackground: 'unset',
  defaultButtonHoverBackground: colorPallet.dimGray,
  defaultButtonActiveBackground: colorPallet.darkGrayLigthV2,
  defaultButtonBorderColor: colorPallet.veryLightGrey,
  primaryButtonBackground: colorPallet.richBlue,
  primaryButtonBackgroundHover: colorPallet.slateBlue,
  primaryButtonBackgroundActive: colorPallet.cornFlowerBlue,
  primaryButtonColor: colorPallet.white,
  primaryButtonV2Background: colorPallet.lightSlateBlue,
  primaryButtonV2BackgroundHover: colorPallet.slateBlue,
  primaryButtonV2BackgroundActive: colorPallet.cornFlowerBlue,
  primaryButtonV2Color: colorPallet.white,
  primaryButtonV2ColorHover: colorPallet.white,
  primaryButtonV2ColorActive: colorPallet.white,
  vaccationIndicatorPopupBackground: colorPallet.black,
  vaccationIndicatorTeamDetailsHeaderBackground: colorPallet.richBlue,
  filterButtonColor: colorPallet.richBlue,
  currentUserVacationBackgroundColor: colorPallet.purpleDark,
  tableBorders: colorPallet.black,
  tableHeadColor: colorPallet.richBlue,
  tableHeadFont: colorPallet.white,
  tableRowColor: colorPallet.gray14,
  tableRowHover: colorPallet.lightGray,
  tableRowFont: colorPallet.darkGray,
  tableRowBorder: colorPallet.black,
  tableOptionsColor: colorPallet.lightSlateBlue,
  tableOptionsBackground: colorPallet.black,
  tableOptionHover: colorPallet.lightGray,
  tableSelectInput: colorPallet.lightGray,
  tableHeadDivider: colorPallet.richBlue,

  timesheetsHeaderBackground: colorPallet.nero,
  timesheetsTableHeaderBackground: colorPallet.nero2,
  timesheetsTableBodyBackground: colorPallet.neroV2,
  timesheetsTableBodyHoursBackground: colorPallet.jaguar,
  timesheetsTableBorderColor: colorPallet.blackV2,
  timesheetsTableCellBackgroundHover: colorPallet.jacksonsPurple,
  timesheetsCalloutBackground: colorPallet.nero,
  timesheetsTableTextMainColor: colorPallet.white,
  timesheetsTableTextSecondaryColor: colorPallet.lightGreylight,
  timesheetsTableTextFooterColor: colorPallet.darkGray,
  timesheetsPopupInputBackground: colorPallet.nero,
  timesheetsPopupInputColor: colorPallet.matterhorn,
  timesheetsPopupBackground: colorPallet.neroV2,
  timesheetsHourPillsBackground: colorPallet.nightRider,
  timesheetsSumHoursColor: colorPallet.darkGray,
  timesheetsDatepickerBackground: colorPallet.neroV2,
  timesheetsDatepikerColor: colorPallet.white,
  timesheetsDatepickerWeekSelectedBackGround: colorPallet.darkSlateBlue,
  timesheetsDatepickerWeekHoverBackGround: colorPallet.weekHoverDark,
  timesheetsDatepickerSelectedWeekHoverBackGround: colorPallet.darkSlateBlue,
  timesheetsCheckIconColor: colorPallet.mantis,
  timesheetInfoIconColor: colorPallet.watermelon,
  timesheetsAlertBackground: colorPallet.temptress,
  timesheetsAlertBorder: colorPallet.rusticRed,
  timesheetsSuccessOverlay: colorPallet.mantis,
  timesheetsInputBorderColor: colorPallet.lightSlateBlue,
  timesheetsNonWorkingDayCellBackgorund: colorPallet.gray14,

  skillsBackground: colorPallet.nero,
  skillsMainBorderColor: colorPallet.neroV3,
  skillsAccordionBackground: colorPallet.gray14,
  skillsAccordionOpenHeaderBackground: colorPallet.neroV2,
  skillsAccordionCloseHeaderBackground: colorPallet.gray14,
  skillsAccordionBorderColor: colorPallet.matterhornV2,
  skillsPopupRadioSectionsDivider: colorPallet.portage,
  skillsMainTextColor: colorPallet.white,
  skillsSecondaryTextColor: colorPallet.veryLightGrey,
  skillsErrorBackground: colorPallet.rusticRedV2,
  skillsErrorMessageBorder: colorPallet.fireEngineRed,
  skillsErrorAlertIconColor: colorPallet.oldRose,
  skillsEditButtonColor: colorPallet.gray14,
  skillsEditButtonBorder: colorPallet.lightGrey,
  skillsEditButtonBackground: colorPallet.neroV2,
  skillsEditButtonTextColor: colorPallet.white,
  skillsButtonsColor: colorPallet.lightGrey,
  skillsLabelColor: colorPallet.lightGrey,
  skillsLevelTextColor: colorPallet.veryLightGrey,
  skillTitleColor: colorPallet.white,
  skillLevelColor: colorPallet.veryLightGrey,

  goalsTableContainerBackground: colorPallet.nero,
  goalsTableHeaderBackground: colorPallet.nero,
  goalsCardBackground: colorPallet.gray14,
  goalsCardText: colorPallet.white,
  goalsCardCommentText: colorPallet.veryLightGrey,
  goalsCardCommentLabel: colorPallet.veryLightGrey,
  goalsMenuItemColor: colorPallet.lightGrey,
  goalsRowDivider: colorPallet.neroV2,
  goalsTextareaBackground: colorPallet.neroV2,

  feedbackBackground: colorPallet.nero,
  feedbackContainersBackground: colorPallet.gray14,
  feedbackDividersColor: colorPallet.matterhornV2,
  feedbackAccordionSelected: colorPallet.jacksonsPurple,
  feedbackCompanyValuesButtonBorderColor: colorPallet.richBlue,
  feedbackEmployeeSuggestionHover: colorPallet.lightGray,

  serviceDeskNotesDivider: colorPallet.portage,
  serviceDeskNoteBackground: colorPallet.neroV2,
  serviceDeskInputNoteBackground: colorPallet.neroV2,
  serviceDeskNoteBorder: colorPallet.neroV2,
  serviceDeskFileAttachmentBorder: colorPallet.gray14,
  serviceDeskMainBackground: colorPallet.nero,
  serviceDeskTextColorPrimary: colorPallet.white,
  serviceDeskTextColorSecondary: colorPallet.veryLightGrey,
  serviceDeskTextColorTertiary: colorPallet.lightGrey,
  serviceDeskTextColorWhite: colorPallet.white,
  serviceDeskRadioButtonColor: colorPallet.slateBlue,
  serviceDeskColorButtonRest: colorPallet.slateBlue,
  serviceDeskInputBackground: colorPallet.neroV2,
  serviceDeskInputDropDownBackground: colorPallet.neroV2,
  serviceDeskInputDropDownHoverBackground: colorPallet.charcoal,
  serviceDeskFileAttachmentBackground: colorPallet.gray14,
  serviceDeskNoteInputText: colorPallet.white,
  serviceDeskSubmitButtonDisabled: colorPallet.darkGray,
  serviceDeskMobileFooterBackground: colorPallet.nero,
  serviceDeskNotesErrors: colorPallet.oldRose,
  serviceDeskTableHeaderCellColor: colorPallet.veryLightGrey,
  serviceDeskTableHeaderCellColorSortingActive: colorPallet.white,
};
